import { useEffect } from "react";

export function useAuthPageBody() {
  useEffect(() => {
    document.body.classList.add("wb-page--home", "wb-page--guest-landing", "wb-page--auth");
    return () => {
      document.body.classList.remove("wb-page--home", "wb-page--guest-landing", "wb-page--auth");
    };
  }, []);
}
